@if ($scanJob(); as scanJob) {
    @if ($can().read.scanJob(scanJob)) {
        <mat-card appearance="outlined" class="cm-scan-job" [class.cm-disabled]="!$can().read.scanJob(null, 'dialog')" (click)="showScanJobDialog(scanJob)">
            <div class="cm-scan-job-checkbox">
                <mat-checkbox
                    [ngModel]="scanJob.active"
                    [disabled]="!$can().update.scanJob()"
                    (ngModelChange)="updateScanJob({active: $event})"
                    (click)="$event.stopPropagation()"
                ></mat-checkbox>
            </div>
            <div class="cm-scan-job-details">
                <div class="cm-scan-job-title">
                    Scan job {{ scanJob.legacyId }} (Active: {{ $activeSubJobsCount() }} | Completed: {{ $completedSubJobsCount() }} | Total:
                    {{ scanJob.subJobsCount }})
                    @if ($can().read.scanJob(null, "logs") && scanJob.logAssignments.length > 0) {
                        <span
                            (click)="downloadLog(scanJob.logAssignments[0].dataObject.downloadUrl); $event.stopPropagation()"
                            matTooltip="Logs"
                            class="cm-scan-job-actions"
                        >
                            <i class="far fa-arrow-to-bottom"></i>
                        </span>
                    }
                    @if ($can().read.scanJob(null, "files")) {
                        <a
                            href
                            (click)="$event.stopPropagation()"
                            routerLink="/files"
                            matTooltip="Show files"
                            [queryParams]="{assignedToId: scanJob.id, assignedToContentType: Enums.ContentTypeModel.ScanJob}"
                            class="cm-scan-job-actions"
                        >
                            <i class="far fa-file"></i>
                        </a>
                    }
                    @if ($canClone()) {
                        @if ($cloning()) {
                            <span class="cm-scan-job-actions" (click)="$event.stopPropagation()">
                                <cm-loading-spinner-icon></cm-loading-spinner-icon>
                            </span>
                        } @else {
                            <span
                                [matMenuTriggerFor]="cloneMenu"
                                (click)="$event.stopPropagation()"
                                matTooltip="Clone for refitting"
                                class="cm-scan-job-actions"
                            >
                                <i class="far fa-copy"></i>
                            </span>
                            <mat-menu #cloneMenu="matMenu">
                                <button mat-menu-item (click)="cloneForRefitting(FittingSchema.Colormass)">Refit with Colormass</button>
                                <button mat-menu-item (click)="cloneForRefitting(FittingSchema.Clo)">Refit with CLO</button>
                            </mat-menu>
                        }
                    }
                </div>
                <div class="cm-scan-job-subtitle">
                    <cm-state-label
                        [stateLabels]="Labels.States.ScanJob"
                        (click)="$event.stopPropagation()"
                        [state]="scanJob.state"
                        [editable]="$can().update.scanJob()"
                        (stateChange)="updateScanJob({state: $event})"
                    >
                    </cm-state-label>
                    @if ($scanJobDuration(); as scanDuration) {
                        <div matTooltip="Processing time" class="cm-scan-job-icon-container">
                            <i class="far fa-clock cm-scan-job-icon"></i>
                            <span class="cm-scan-job-icon-text">{{ scanDuration | cmDuration }}</span>
                        </div>
                    }
                    <div matTooltip="Creation time" class="cm-scan-job-icon-container">
                        <i class="far fa-pen cm-scan-job-icon"></i>
                        <span class="cm-scan-job-icon-text">
                            @if (scanJob.createdAt) {
                                {{ scanJob.createdAt | cmFormatDate }}
                            }
                        </span>
                    </div>
                    <div matTooltip="Scanner" class="cm-scan-job-icon-container">
                        <i class="far fa-camera cm-scan-job-icon"></i>
                        <span class="cm-scan-job-icon-text">{{ scanJob.createdBy?.name }}</span>
                    </div>
                    <div matTooltip="Sample rotation" class="cm-scan-job-icon-container">
                        <i class="cm-scan-job-icon cm-scan-job-icon-rotation far fa-redo"></i>
                        <span class="cm-scan-job-icon-text">{{ scanJob.sampleRotation }}°</span>
                    </div>
                    @if (scanJob.textureSet?.fittingSchema) {
                        <div matTooltip="Fitting schema" class="cm-scan-job-icon-container">
                            <i class="far fa-cogs cm-scan-job-icon cm-scan-job-icon-cogs"></i>
                            <span class="cm-scan-job-icon-text">{{ scanJob.textureSet?.fittingSchema }}</span>
                        </div>
                    }
                </div>
            </div>
        </mat-card>
    }
}
